import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";

import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import {
  postEnviarPresupuesto,
  postEnviarSolicitud,
  setActiveStep,
} from "../../../actions/autorizaciones/Autorizaciones";
import { startAlerta } from "../../../actions/ui/alertas";

import { STEPPER_AUTORIZACIONES, TIPOS_AUTORIZACIONES } from "../../../utils/constants";

import { AutorizacionesCard } from "../UI/AutorizacionesCard";
import AutorizacionesCoseguroImpresion from "./AutorizacionesCoseguroImpresion";

export const AutorizacionesConfirmacion = () => {
  const dispatch = useDispatch();

  const { solicitudSeleccionada = {}, presupuestoSeleccionado = {} } =
    useSelector((state) => state.autorizaciones
    );

  let idSolicitud = 0;
  let idPresupuesto = null;

  if (!!solicitudSeleccionada) {
    idSolicitud = solicitudSeleccionada?.idSolicitud;
  }
  if (idSolicitud === 0 && !!presupuestoSeleccionado) {
    idPresupuesto = presupuestoSeleccionado.idPresupuesto;
  }

  const [redirect, setRedirect] = useState(false);
  const [esUrgente, setEsUrgente] = useState("noEsUrgente");
  const [opcionesSolicitudEnviada, setOpcionesSolicitudEnviada] = useState(false);

  const onClickConfirmarHandler = () => {
    const urgente = esUrgente === "esUrgente" ? true : false;
    if (esUrgente === "") {
      dispatch(startAlerta(`Seleccione el grado de importancia.`, "error"));
    } else {
      if (idSolicitud !== 0) {
        dispatch(postEnviarSolicitud(idSolicitud, urgente, setRedirect, setOpcionesSolicitudEnviada));
      } else if (idPresupuesto !== 0) {
        dispatch(postEnviarPresupuesto(idPresupuesto, urgente, setRedirect));
      }
    }
  };

  return (
    <AutorizacionesCard width={"55%"}>
      {opcionesSolicitudEnviada &&
        <AutorizacionesCoseguroImpresion
          redirectHome={true}
          open={opcionesSolicitudEnviada}
          closeModalHandler={() => setOpcionesSolicitudEnviada(false)}
        />
      }
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1.5rem",
          }}
        >
          <FormControl>
            <FormLabel style={{ fontSize: "1.2rem" }}>Urgente:</FormLabel>
            <RadioGroup
              value={esUrgente}
              onChange={(e) => setEsUrgente(e.target.value)}
            >
              <FormControlLabel
                value="esUrgente"
                control={<Radio />}
                label="Si"
              />
              <FormControlLabel
                value="noEsUrgente"
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: "3rem" }}
          onClick={() => {
            if (solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.ESTADIAS ||
              solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PASAJES) {
              dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DETALLES_ORDEN));
            } else {
              dispatch(setActiveStep(STEPPER_AUTORIZACIONES.PRACTICAS));
            }
          }}
        >
          Anterior
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickConfirmarHandler}
        >
          Confirmar
        </Button>
      </div>
      {redirect && (
        <Redirect
          to={{
            pathname: "/autorizaciones",
          }}
        />
      )}
    </AutorizacionesCard>
  );
};
